const DATA = {
    websiteTitle: " - Telegram sex chat",
};

export default DATA;
